(function() {
    'use strict';

    angular
        .module('atheer.content', [

        ]);
})();
